var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uni-answerSheet" }, [
    _c("div", { staticClass: "settings" }, [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("em"),
          _c("div", { staticClass: "set", on: { click: _vm.openCalculate } }, [
            _c("i", {
              staticClass: "iconfont iconhaofangtuo400iconfontjisuanqi",
            }),
            _c("p", [_vm._v("计算器")]),
          ]),
          _c(
            "el-popover",
            { attrs: { placement: "bottom", width: "80", trigger: "click" } },
            [
              _c(
                "ul",
                { staticClass: "uni-font-change" },
                _vm._l(_vm.fontSize, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.name,
                      staticClass: "item",
                      class: _vm.fontClass == item.value ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.fontChange(item.value)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(item.name) + " ")]
                  )
                }),
                0
              ),
              _c(
                "div",
                {
                  staticClass: "set",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("i", { staticClass: "iconfont iconWord" }),
                  _c("p", [_vm._v("字体")]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
    ]),
    _vm.showTime
      ? _c("div", { staticClass: "settings" }, [
          _vm._m(1),
          _c("div", { staticClass: "sheetSetCen" }, [
            _c("div", { staticClass: "content" }, [
              _c("em"),
              _c("span", { staticClass: "mal30 mar20 black" }, [
                _vm._v("剩余时间:"),
              ]),
              _c("span", { staticClass: "f18 oringe" }, [
                _vm._v(_vm._s(_vm.endDate)),
              ]),
            ]),
          ]),
        ])
      : _vm._e(),
    _c("div", { staticClass: "topic" }, [
      _c("div", { staticClass: "title" }, [
        _c("i", { staticClass: "iconfont icondatiqia" }),
        _c("span", { staticClass: "active" }, [_vm._v("答题卡")]),
        _c("span", [_vm._v(_vm._s(_vm.done.length) + "/" + _vm._s(_vm.total))]),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        _vm._l(_vm.datas, function (item, key) {
          return _c("div", { key: key, staticClass: "main" }, [
            _c("div", { staticClass: "header" }, [
              _c("em"),
              _c("span", [_vm._v(_vm._s(item.question_title))]),
              _c("span", [
                _vm._v(
                  "(共" +
                    _vm._s(item.list.length) +
                    "题,共" +
                    _vm._s(item.fraction) +
                    "分)"
                ),
              ]),
            ]),
            _c(
              "ul",
              _vm._l(item.list, function (item2, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    class:
                      _vm.isAnalysis || _vm.topicLx
                        ? _vm.toggleClass(item2.make_status)
                        : _vm.toggleClass(item2.is_make),
                    on: {
                      click: function ($event) {
                        return _vm.jump(item2.sort)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item2.sort) + " ")]
                )
              }),
              0
            ),
          ])
        }),
        0
      ),
    ]),
    _c("div", { staticClass: "tagging" }, [
      _c(
        "ul",
        _vm._l(_vm.labelList, function (item, index) {
          return _c("li", { key: index }, [
            _c("em", { class: item.class }),
            _c("span", [_vm._v(_vm._s(item.name))]),
          ])
        }),
        0
      ),
      _c("div", { staticClass: "submit" }, [
        _c("div", { on: { click: _vm.submit } }, [
          _vm._v(_vm._s(_vm.isAnalysis ? "退出" : "提交")),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "calculate" },
      [
        _c(
          "el-drawer",
          {
            attrs: {
              title: "我是标题",
              visible: _vm.calculateDialog,
              "with-header": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.calculateDialog = $event
              },
            },
          },
          [_c("calculate")],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top" }, [
      _c("i", { staticClass: "iconfont iconSettingscontroloptions" }),
      _c("span", [_vm._v("工具栏")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "top" }, [
      _c("i", { staticClass: "iconfont iconnaozhong" }),
      _vm._v("倒计时 "),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }